// Global styles. Gatsby only inlines CSS from the app bundle and the page's
// own component chunk, so templates that import no CSS (blog posts, projects,
// tag pages, 404) depend on these imports to be styled on a full page load.
import "./src/utils/normalize.css";
import "./src/utils/css/screen.css";

export const onPreRouteUpdate = () => {
  document
    .querySelectorAll(".transition-fade")
    .forEach(el => el.classList.add("is-animating"));
};

export const onRouteUpdate = () => {
  setTimeout(() => {
    document
      .querySelectorAll(".transition-fade")
      .forEach(el => el.classList.remove("is-animating"));
  }, 0);
};
